import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/blank-notification.svg'
import _imports_1 from '@/assets/no-select-notification.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7cc6e3c0")

_pushScopeId("data-v-7cc6e3c0")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "AI自動返信設定", -1)
const _hoisted_4 = { class: "flex-grow flex bg-primary-100 w-full" }
const _hoisted_5 = { class: "flex-1 flex flex-col h-full bg-white rounded-t-md max-width-dynamic" }
const _hoisted_6 = { class: "flex flex-shrink-0 justify-between items-center lg:px-8 pl-2 py-2 h-12 border-b border-primary-100" }
const _hoisted_7 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "未読一覧", -1)
const _hoisted_9 = {
  key: 0,
  class: "bg-red-400 rounded-full h-6 w-max flex items-center justify-center px-2"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "全て既読", -1)
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "メッセージ", -1)
const _hoisted_16 = { class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "メッセージ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "学習室", -1)
const _hoisted_20 = { class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "学習室", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "タイムキーパー", -1)
const _hoisted_24 = { class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "タイムキーパー", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "提出物", -1)
const _hoisted_28 = { class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, "提出物", -1)
const _hoisted_30 = {
  key: 0,
  class: "flex-grow overflow-y-scroll"
}
const _hoisted_31 = {
  key: 0,
  class: "flex justify-center my-4"
}
const _hoisted_32 = {
  key: 1,
  class: "flex-1 flex flex-col justify-center items-center"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Blank Notification",
  class: "w-1/2 mb-4"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-400 text-center" }, " 新しいお知らせはありません ", -1)
const _hoisted_35 = { class: "flex-1 hidden lg:flex flex-col h-full bg-white rounded-t-md ml-1 max-width-dynamic" }
const _hoisted_36 = {
  key: 1,
  class: "h-full flex flex-col justify-center items-center"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "Blank Notification",
  class: "w-1/2 mb-4"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-400 text-center" }, " 通知を選択すると関連情報が表示されます ", -1)
const _hoisted_39 = {
  key: 1,
  class: "flex"
}
const _hoisted_40 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_41 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_42 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_43 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " 通知メッセージ画面が移動しました ", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" 通知メッセージの確認は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIの通知メッセージ画面から行えます。 ")
], -1)
const _hoisted_45 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_table_condition_item = _resolveComponent("m-table-condition-item")
  const _component_MnNotificationItem = _resolveComponent("MnNotificationItem")
  const _component_MSMessagePanel = _resolveComponent("MSMessagePanel")
  const _component_MNotificationSettingModal = _resolveComponent("MNotificationSettingModal")

  return (_ctx.isStudyRoomOnly || _ctx.isAdmin)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "通知メッセージ",
              breadcrumbs: []
            }, {
              actions: _withId(() => [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 0,
                      color: "secondary-500",
                      "hover-color": "secondary-600",
                      outline: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSettingModalOpen = true))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "plus",
                          width: "3",
                          class: "mr-2 transform rotate-90 z-0"
                        }),
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode("main", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.allNotificationsLength > 0)
                      ? (_openBlock(), _createBlock("span", _hoisted_9, [
                          (_ctx.allNotificationsLength == 100)
                            ? (_openBlock(), _createBlock("span", _hoisted_10, "99+"))
                            : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.allNotificationsLength), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_m_button, {
                    color: "gray-500",
                    size: "sm",
                    "font-weight": "normal",
                    text: "",
                    onClick: _ctx.checkAllNotification
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "check",
                        class: "mr-2"
                      }),
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("button", {
                    class: ["flex items-center text-gray-600 px-2 py-1 rounded cursor-pointer transition-colors duration-300 hover:bg-white hover:text-primary-500", {
                'text-primary-500': _ctx.allNotificationTypes.every(type =>
                  _ctx.selectedNotificationTypes.includes(type)
                )
              }],
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAllFilter()))
                  }, " 全て ", 2),
                  _createVNode(_component_m_table_condition_item, {
                    active: _ctx.selectedMessageTypes.length !== _ctx.messageTypes.length,
                    class: "lg:block"
                  }, {
                    body: _withId(() => [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_16, [
                          _hoisted_17,
                          _createVNode("button", {
                            class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAllMessageTypes && _ctx.selectAllMessageTypes(...args)))
                          }, " 全選択 "),
                          _createVNode("button", {
                            class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deselectAllMessageTypes && _ctx.deselectAllMessageTypes(...args)))
                          }, " 全解除 ")
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messageTypes, (messageType) => {
                          return (_openBlock(), _createBlock("li", {
                            key: messageType,
                            class: "list-none flex items-center w-full px-4 py-2 text-sm"
                          }, [
                            _withDirectives(_createVNode("input", {
                              id: messageType,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedMessageTypes = $event)),
                              type: "checkbox",
                              name: messageType,
                              value: messageType,
                              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                            }, null, 8, ["id", "name", "value"]), [
                              [_vModelCheckbox, _ctx.selectedMessageTypes]
                            ]),
                            _createVNode("label", {
                              for: messageType,
                              class: "ml-2 block text-gray-700"
                            }, _toDisplayString(_ctx.convertToLogicalName(messageType)), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_14,
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_m_table_condition_item, {
                    active: 
                _ctx.selectedLearningRoomMessageTypes.length !==
                  _ctx.learningRoomMessageTypes.length
              ,
                    class: "lg:block"
                  }, {
                    body: _withId(() => [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_20, [
                          _hoisted_21,
                          _createVNode("button", {
                            class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectAllLearningRoomMessageTypes && _ctx.selectAllLearningRoomMessageTypes(...args)))
                          }, " 全選択 "),
                          _createVNode("button", {
                            class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deselectAllLearningRoomMessageTypes && _ctx.deselectAllLearningRoomMessageTypes(...args)))
                          }, " 全解除 ")
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.learningRoomMessageTypes, (learningRoomMessageType) => {
                          return (_openBlock(), _createBlock("li", {
                            key: learningRoomMessageType,
                            class: "list-none flex items-center w-full px-4 py-2 text-sm"
                          }, [
                            _withDirectives(_createVNode("input", {
                              id: learningRoomMessageType,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedLearningRoomMessageTypes = $event)),
                              type: "checkbox",
                              name: learningRoomMessageType,
                              value: learningRoomMessageType,
                              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                            }, null, 8, ["id", "name", "value"]), [
                              [_vModelCheckbox, _ctx.selectedLearningRoomMessageTypes]
                            ]),
                            _createVNode("label", {
                              for: learningRoomMessageType,
                              class: "ml-2 block text-gray-700"
                            }, _toDisplayString(_ctx.convertToLogicalName(learningRoomMessageType)), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_18,
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_m_table_condition_item, {
                    active: 
                _ctx.selectedTimeKeeperMessageTypes.length !==
                  _ctx.timeKeeperMessageTypes.length
              ,
                    class: "lg:block"
                  }, {
                    body: _withId(() => [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_24, [
                          _hoisted_25,
                          _createVNode("button", {
                            class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectAllTimeKeeperMessageTypes && _ctx.selectAllTimeKeeperMessageTypes(...args)))
                          }, " 全選択 "),
                          _createVNode("button", {
                            class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.deselectAllTimeKeeperMessageTypes && _ctx.deselectAllTimeKeeperMessageTypes(...args)))
                          }, " 全解除 ")
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeKeeperMessageTypes, (timeKeeperMessageType) => {
                          return (_openBlock(), _createBlock("li", {
                            key: timeKeeperMessageType,
                            class: "list-none flex items-center w-full px-4 py-2 text-sm"
                          }, [
                            _withDirectives(_createVNode("input", {
                              id: timeKeeperMessageType,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedTimeKeeperMessageTypes = $event)),
                              type: "checkbox",
                              name: timeKeeperMessageType,
                              value: timeKeeperMessageType,
                              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                            }, null, 8, ["id", "name", "value"]), [
                              [_vModelCheckbox, _ctx.selectedTimeKeeperMessageTypes]
                            ]),
                            _createVNode("label", {
                              for: timeKeeperMessageType,
                              class: "ml-2 block text-gray-700"
                            }, _toDisplayString(_ctx.convertToLogicalName(timeKeeperMessageType)), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_m_table_condition_item, {
                    active: 
                _ctx.selectedSubmissionMessageTypes.length !==
                  _ctx.submissionMessageTypes.length
              ,
                    class: "lg:block"
                  }, {
                    body: _withId(() => [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_28, [
                          _hoisted_29,
                          _createVNode("button", {
                            class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.selectAllSubmissionMessageTypes && _ctx.selectAllSubmissionMessageTypes(...args)))
                          }, " 全選択 "),
                          _createVNode("button", {
                            class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deselectAllSubmissionMessageTypes && _ctx.deselectAllSubmissionMessageTypes(...args)))
                          }, " 全解除 ")
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.submissionMessageTypes, (submissionMessageType) => {
                          return (_openBlock(), _createBlock("li", {
                            key: submissionMessageType,
                            class: "list-none flex items-center w-full px-4 py-2 text-sm"
                          }, [
                            _withDirectives(_createVNode("input", {
                              id: submissionMessageType,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedSubmissionMessageTypes = $event)),
                              type: "checkbox",
                              name: submissionMessageType,
                              value: submissionMessageType,
                              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                            }, null, 8, ["id", "name", "value"]), [
                              [_vModelCheckbox, _ctx.selectedSubmissionMessageTypes]
                            ]),
                            _createVNode("label", {
                              for: submissionMessageType,
                              class: "ml-2 block text-gray-700"
                            }, _toDisplayString(_ctx.convertToLogicalName(submissionMessageType)), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_26,
                      _hoisted_27
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]),
                (_ctx.notifications.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_30, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                        return (_openBlock(), _createBlock(_component_MnNotificationItem, {
                          key: notification.ref.id,
                          item: notification,
                          selected: _ctx.selectedNotificationId == notification.ref.id,
                          onConfirm: ($event: any) => (_ctx.confirm(notification)),
                          onCheck: ($event: any) => (_ctx.check(notification.ref.id)),
                          onSelect: ($event: any) => (_ctx.select(notification.ref.id))
                        }, null, 8, ["item", "selected", "onConfirm", "onCheck", "onSelect"]))
                      }), 128)),
                      (_ctx.notifications.length >= _ctx.limit && !_ctx.finished)
                        ? (_openBlock(), _createBlock("div", _hoisted_31, [
                            _createVNode(_component_m_button, {
                              color: "gray-700",
                              "font-weight": "normal",
                              text: "",
                              class: "underline",
                              onClick: _ctx.getMoreNotifications
                            }, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("span", null, "さらに読み込む", 512), [
                                  [_vShow, !_ctx.load]
                                ]),
                                _withDirectives(_createVNode("span", null, "読み込み中...", 512), [
                                  [_vShow, _ctx.load]
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("section", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34
                    ]))
              ]),
              _createVNode("div", _hoisted_35, [
                (_ctx.selectedNotificationId)
                  ? (_openBlock(), _createBlock(_component_MSMessagePanel, {
                      key: 0,
                      student: _ctx.messageStudent,
                      "in-recess": _ctx.inRecess
                    }, null, 8, ["student", "in-recess"]))
                  : (_openBlock(), _createBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _hoisted_38
                    ]))
              ])
            ])
          ])
        ]),
        (_ctx.isSettingModalOpen)
          ? (_openBlock(), _createBlock(_component_MNotificationSettingModal, {
              key: 0,
              "is-admin": _ctx.isAdmin,
              onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isSettingModalOpen = false))
            }, null, 8, ["is-admin"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_39, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_MHeaderPanel, {
            title: "通知メッセージ",
            breadcrumbs: []
          }),
          _createVNode("main", _hoisted_41, [
            _createVNode("section", _hoisted_42, [
              _hoisted_43,
              _hoisted_44,
              _createVNode("div", _hoisted_45, [
                _createVNode("a", {
                  href: _ctx.newNotificationUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しい通知メッセージ画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})